module.exports = __webpack_public_path__ + "static/assistance-mobile-kr-17d19ab7d897d791d658b7b3f3a48a8c.png";